import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

// Actions
import { setAuthState } from "../../state/user/actions";

// Config
import { userTypes } from "../../config/values";

// Components
import LoadingSection from "../LoadingSection/LoadingSection";

const VictimFormHandler = ({
  children,
  setCoord,
  setFieldValue,
  setUserCapacity,
  userCapacity
}) => {
  const dispatch = useDispatch();
  const { userDetails, authState, loadingDetails } = useSelector(
    state => state.user
  );

  React.useEffect(() => {
    if (userCapacity === userTypes.Victim && userDetails) {
      const { birthDate, givenName, phoneNumber, surname } = userDetails;

      setFieldValue("givenName", givenName || "");
      setFieldValue("familyName", surname || "");
      setFieldValue("dateOfBirth", birthDate || "");
      setFieldValue("country", phoneNumber?.isoCountryCode || "GB");
      setFieldValue("number", phoneNumber?.nationalNumber || "");
    }
  }, [userDetails, setFieldValue, userCapacity]);

  React.useEffect(() => {
    if (authState && authState.data) {
      const {
        coordinate,
        country,
        dateOfBirth,
        description,
        dateTime,
        familyName,
        givenName,
        incidentTypeId,
        location,
        number,
        userCapacity: capacity
      } = authState.data;

      setFieldValue("givenName", givenName);
      setFieldValue("familyName", familyName);
      setFieldValue("dateOfBirth", dateOfBirth);
      setFieldValue("country", country);
      setFieldValue("number", number);
      setFieldValue("description", description);
      setFieldValue("dateTime", dateTime);
      setFieldValue("incidentTypeId", incidentTypeId);
      setFieldValue("location", location);
      if (coordinate) {
        setCoord({
          lat: () => coordinate.latitude,
          lng: () => coordinate.longitude
        });
      }
      setUserCapacity(capacity);

      dispatch(setAuthState(null));
    }
  }, [dispatch, authState, setCoord, setFieldValue, setUserCapacity]);

  return userCapacity === userTypes.Victim && loadingDetails ? (
    <LoadingSection normalHeight />
  ) : (
    children
  );
};

VictimFormHandler.propTypes = {
  children: PropTypes.node.isRequired,
  setCoord: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setUserCapacity: PropTypes.func.isRequired,
  userCapacity: PropTypes.string.isRequired
};

export default VictimFormHandler;
